import React, { useCallback, useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import { useObserver } from 'mobx-react-lite';
import tagsStore from '../../../stores/tags.store';
import serverStore from '../../../stores/server.store';
import styled from 'styled-components';
import {
    GoBackStyled
} from '../../../style/components/common.styled';
import EditServerName from './components/serverEdit/EditServerName';
import LoaderComponent from '../../components/Loader.component';
import TagsModal from '../../components/tags/TagsModal';
import TagsList from '../../components/tags/TagsList';
import AlarmsSettings from '../../components/alarmsSettings/AlarmsSettings';
import alarmsStore from '../../../stores/alarms.store';
import {
    EuiSpacer,
    EuiButton, EuiCodeBlock, EuiCopy, EuiIcon
} from '@elastic/eui';
import { addToast } from '../../components/toasts/Toast';
import uptimeStore from '../../../stores/uptime.store';
import { Redirect, useHistory } from 'react-router-dom';
import { MONITOR_TYPES } from '../../../constants/monitor.types';
import mongoDbStore from "../../../stores/mongodb.store";
import { loadDetailData } from '../../../servises/detail-loading.service';
import MonitorLoadError from './components/MonitorLoadError';

export const StyledEditWrapper = styled.div`
  width: min(1120px, calc(100% - 28px));
  display: grid;
  grid-gap: 14px;
  margin: 14px auto 30px;
  min-height: 500px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    width: 100%;
    padding: 0 10px 20px;
    margin-top: 10px;
  }

  h1 {
    font-size: 30px;
    margin: 0;
    line-height: 1.15;
    word-break: break-word;

    @media (max-width: 600px) {
      font-size: 24px;
    }
  }

  h3 {
    text-align: left;
    font-size: 16px;
    margin: 0;
  }

  .bonya {
    margin-top: 0;
  }
`;

export const EditZoneStyled = styled.div`
  background: linear-gradient(135deg, rgb(35, 37, 47) 0%, rgb(24, 25, 30) 100%);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 18px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: ${ props => props.accentColor || 'rgb(0, 128, 213)' };
  }
`;

export const TagsWrapperStyled = styled.div`
  padding: 4px 0 14px;
`;

export const DeleteServerZoneStyled = styled.div`
  margin-bottom: 20px !important;
  background: rgba(255, 77, 79, 0.05);
  border: 1px solid rgb(255 77 79 / 34%);
  border-radius: 8px;
  padding: 18px;

  .are-you-sure {
    color: rgba(255, 255, 255, 0.86);
    margin-bottom: 12px;
  }
`;

export const FooterButtons = styled.div`
  text-align: left;
`;

const DeleteAgentStyled = styled.div`
  background: linear-gradient(135deg, rgb(35, 37, 47) 0%, rgb(24, 25, 30) 100%);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 18px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: #f9be49;
  }
`;

const EditSurfaceStyled = styled.div`
  width: 100%;
  min-height: 200px;
  padding: 18px;
  border-radius: 8px;
  background-color: rgb(29,30,36);
  box-shadow: rgb(0 0 0 / 28%) 0px 0.9px 4px, rgb(0 0 0 / 21%) 0px 2.6px 8px, rgb(0 0 0 / 18%) 0px 5.7px 12px, rgb(0 0 0 / 14%) 0px 15px 15px;

  @media (max-width: 600px) {
    padding: 12px;
  }
`;

const EditHeroStyled = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-gap: 20px;
  align-items: start;
  padding-bottom: 18px;
  margin-bottom: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }

  .eyebrow {
    color: #36A2EF;
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 7px;
    text-transform: uppercase;
  }

  .summary {
    color: rgba(255, 255, 255, 0.62);
    font-size: 13px;
    line-height: 1.55;
    margin-top: 8px;
    max-width: 680px;
  }

  .hero-actions {
    display: flex;
    justify-content: flex-end;

    @media (max-width: 760px) {
      justify-content: flex-start;
    }
  }
`;

const ServerMetaGridStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(120px, 1fr));
  grid-gap: 10px;
  margin-bottom: 18px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

const ServerMetaItemStyled = styled.div`
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 6px;
  min-width: 0;
  padding: 10px 12px;

  .label {
    color: rgba(255, 255, 255, 0.48);
    display: block;
    font-size: 11px;
    margin-bottom: 5px;
  }

  .value {
    color: rgba(255, 255, 255, 0.9);
    display: block;
    font-family: Consolas, Monaco, monospace;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const ManagementGridStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.8fr);
  grid-gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const ColumnStyled = styled.div`
  display: grid;
  grid-gap: 16px;
  align-content: start;
`;

const SectionHeaderStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;

  .section-icon {
    align-items: center;
    background: rgba(0, 128, 213, 0.12);
    border: 1px solid rgba(0, 128, 213, 0.25);
    border-radius: 6px;
    color: #36A2EF;
    display: flex;
    flex: 0 0 30px;
    height: 30px;
    justify-content: center;
    width: 30px;
  }

  p {
    color: rgba(255, 255, 255, 0.58);
    font-size: 12px;
    line-height: 1.45;
    margin: 5px 0 0;
  }
`;

const TagsActionsStyled = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const AgentCopyStyled = styled.div`
  .copy-help {
    color: rgba(255, 255, 255, 0.58);
    font-size: 12px;
    line-height: 1.45;
    margin: 0 0 12px;
  }

  .euiCodeBlock {
    text-align: left;
  }
`;

const DangerActionsStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const ServerEditPage = props => {
    document.title = 'Server Edit - SyAgent';
    const { serverId } = props.match.params;

    const redirect = () => {
        props.history.push('/servers');
    };

    return useObserver(() => (
        <Observed
            tags={ tagsStore.tags }
            serverId={ serverId }
            handleRedirect={ redirect }
            servers={ serverStore.serversListObj }
            serverAlarmsSettingsObj={ alarmsStore.alarmsSettingsByServer }
        />
    ));
};

const Observed = (props) => {
    const {
        serverId,
        servers,
        handleRedirect,
        serverAlarmsSettingsObj
    } = props;

    const history = useHistory();
    const [loader, setLoader] = useState(true);
    const [loadedServerId, setLoadedServerId] = useState(null);
    const [serverListLoaded, setServerListLoaded] = useState(false);
    const [loadFailed, setLoadFailed] = useState(false);
    const [loadSequence, setLoadSequence] = useState(0);

    const server = servers[serverId];
    const serverAlarmsSettings = serverAlarmsSettingsObj[serverId];
    const metric = server && server.metrics ? server.metrics[0] : null;
    const serverData = server && server.serverData ? server.serverData : {};
    const serverObjectId = server ? server._id : null;

    useEffect(() => {
        let active = true;
        setLoader(true);
        setServerListLoaded(false);
        setLoadFailed(false);
        const getsData = async () => {
            const secondaryFailed = await loadDetailData(
                serverStore.getServers(true),
                [
                    tagsStore.getTags(),
                    alarmsStore.getAlarmsSettings(serverId),
                    uptimeStore.getUptime(),
                    mongoDbStore.getMongoDb()
                ]
            );
            if (secondaryFailed) {
                addToast('Some monitor settings could not be loaded', 'error');
            }
            if (active) {
                setServerListLoaded(true);
            }
        };

        getsData()
            .catch(error => {
                addToast(error.message || 'Failed to load monitor', 'error');
                if (active) {
                    setLoadFailed(true);
                }
            })
            .finally(() => {
                if (active) {
                    setLoadedServerId(serverId);
                    setLoader(false);
                }
            });
        return () => {
            active = false;
        };
    }, [serverId, loadSequence]);

    const goSomewhere = e => {
        e.preventDefault();
        history.push(`/servers/${ serverId }`);
    };

    const [areYouSureState, setAreYouSureState] = useState(false);
    const [isTagsModalOpen, setIsTagsModalOpen] = useState(false);
    const [deleteSending, setDeleteSending] = useState(false);

    const handleDelete = useCallback(async e => {
        if (deleteSending) {
            return;
        }

        setDeleteSending(true);
        try {
            await serverStore.deleteServer(serverObjectId);
            addToast('Server deleted', 'suc');
            handleRedirect();
        } catch (error) {
            addToast(error.message || 'Failed to delete server', 'error');
        } finally {
            setDeleteSending(false);
        }

    }, [deleteSending, handleRedirect, serverObjectId]);

    return (
        <main className="servers">
            { (loader || loadedServerId !== serverId) && (
                <LoaderComponent/>
            ) }
            { !loader && loadedServerId === serverId && serverListLoaded && !server && (
                <Redirect to="/404"/>
            ) }
            { !loader && loadedServerId === serverId && loadFailed && (
                <MonitorLoadError onRetry={ () => setLoadSequence(value => value + 1) }/>
            ) }
            { !loader && loadedServerId === serverId && !loadFailed && serverListLoaded && server && (
                <>
                    <Header/>
                    <StyledEditWrapper>
                        <GoBackStyled>
                            <EuiButton onClick={ goSomewhere }
                                       size="s"
                                       iconType={ 'returnKey' }
                                       color={ 'text' }>
                                Go back to Server
                            </EuiButton>
                        </GoBackStyled>
                        <EditSurfaceStyled>
                            <EditHeroStyled>
                                <div>
                                    <div className="eyebrow">Server settings</div>
                                    <h1>{ server ? server.name : 'Server management' }</h1>
                                    <div className="summary">
                                        Update the server name, labels, alert thresholds, and local agent cleanup from one place.
                                    </div>
                                </div>
                                <div className="hero-actions">
                                    <EuiButton
                                        onClick={ goSomewhere }
                                        size="s"
                                        iconType={ 'stats' }
                                        color={ 'primary' }
                                        fill
                                    >
                                        View metrics
                                    </EuiButton>
                                </div>
                            </EditHeroStyled>

                            { server && (
                                <ServerMetaGridStyled>
                                    <ServerMetaItemStyled>
                                        <span className="label">Server ID</span>
                                        <span className="value" title={ server._id }>{ server._id }</span>
                                    </ServerMetaItemStyled>
                                    <ServerMetaItemStyled>
                                        <span className="label">IPv4</span>
                                        <span className="value">{ metric && metric.ipv4 ? metric.ipv4 : 'No data yet' }</span>
                                    </ServerMetaItemStyled>
                                    <ServerMetaItemStyled>
                                        <span className="label">Last update</span>
                                        <span className="value">{ serverData.timeAgo || 'No data yet' }</span>
                                    </ServerMetaItemStyled>
                                    <ServerMetaItemStyled>
                                        <span className="label">Agent data</span>
                                        <span className="value">{ serverData.agentPushedTheData ? 'Receiving' : 'Waiting' }</span>
                                    </ServerMetaItemStyled>
                                </ServerMetaGridStyled>
                            ) }

                            <ManagementGridStyled>
                                <ColumnStyled>
                                    <EditZoneStyled className="bonya" accentColor="rgb(0, 128, 213)">
                                        <SectionHeaderStyled>
                                            <span className="section-icon">
                                                <EuiIcon type="inputOutput" size="m"/>
                                            </span>
                                            <div>
                                                <h3>Edit server</h3>
                                                <p>Use a clear display name so this host is easy to recognize in alerts and dashboards.</p>
                                            </div>
                                        </SectionHeaderStyled>
                                        { server && (
                                            <EditServerName server={ server }
                                            />
                                        ) }
                                    </EditZoneStyled>
                                    <EditZoneStyled className="bonya" accentColor="#50bc5e">
                                        <SectionHeaderStyled>
                                            <span className="section-icon">
                                                <EuiIcon type="tag" size="m"/>
                                            </span>
                                            <div>
                                                <h3>Tags</h3>
                                                <p>Group this server by team, environment, customer, or workload.</p>
                                            </div>
                                        </SectionHeaderStyled>
                                        <TagsWrapperStyled>
                                            { server && (
                                                <TagsList
                                                    serverId={ serverId }
                                                    serverTags={ server.tags }
                                                    monitorType={ MONITOR_TYPES.SERVER }
                                                />
                                            ) }
                                        </TagsWrapperStyled>
                                        <TagsActionsStyled>
                                            <EuiButton
                                                size="s"
                                                onClick={ () => setIsTagsModalOpen(true) }
                                                iconType="plusInCircle"
                                                fill
                                            >
                                                Edit tags
                                            </EuiButton>
                                        </TagsActionsStyled>

                                    </EditZoneStyled>
                                    <EditZoneStyled className="bonya" accentColor="#f9be49">
                                        <SectionHeaderStyled>
                                            <span className="section-icon">
                                                <EuiIcon type="alert" size="m"/>
                                            </span>
                                            <div>
                                                <h3>Alarm settings</h3>
                                                <p>Adjust alert sensitivity for this server without changing other monitors.</p>
                                            </div>
                                        </SectionHeaderStyled>
                                        { server && serverAlarmsSettings && (
                                            <AlarmsSettings
                                                serverAlarmsSettings={ serverAlarmsSettings }/>
                                        ) }
                                    </EditZoneStyled>
                                </ColumnStyled>

                                <ColumnStyled>
                                    <DeleteAgentStyled className="bonya">
                                        <SectionHeaderStyled>
                                            <span className="section-icon">
                                                <EuiIcon type="compute" size="m"/>
                                            </span>
                                            <div>
                                                <h3>Agent cleanup</h3>
                                                <p>Run this command on the monitored host when you want to remove the local SyAgent service.</p>
                                            </div>
                                        </SectionHeaderStyled>
                                        <AgentCopyStyled>
                                            <p className="copy-help">This removes `/etc/syAgent`, clears the syAgent cron entry, and deletes the local user.</p>
                                            <EuiCodeBlock language="bash" fontSize="s"
                                                          paddingSize="m">
                                                rm -R /etc/syAgent && (crontab -u
                                                syAgent -l | grep -v
                                                "/etc/syAgent/sh-agent.sh") |
                                                crontab -u
                                                syAgent - && userdel syAgent
                                            </EuiCodeBlock>
                                            <EuiSpacer size="m"/>

                                            <EuiCopy
                                                textToCopy={ 'rm -R /etc/syAgent && (crontab -u syAgent -l | grep -v "/etc/syAgent/sh-agent.sh") | crontab -u syAgent - && userdel syAgent' }>
                                                { copy => (
                                                    <EuiButton onClick={ copy }
                                                               size="s"
                                                               iconType={ 'copyClipboard' }
                                                               color={ 'success' }>Copy command</EuiButton>
                                                ) }
                                            </EuiCopy>
                                        </AgentCopyStyled>
                                    </DeleteAgentStyled>
                                    <DeleteServerZoneStyled className="bonya">
                                        <SectionHeaderStyled>
                                            <span className="section-icon">
                                                <EuiIcon type="trash" size="m"/>
                                            </span>
                                            <div>
                                                <h3>Danger zone</h3>
                                                <p>Deleting a server removes it from monitoring and sends you back to the monitor list.</p>
                                            </div>
                                        </SectionHeaderStyled>
                                        { !areYouSureState && (
                                            <EuiButton
                                                size="s"
                                                iconType={ 'trash' }
                                                color="danger"

                                                onClick={ () => setAreYouSureState(
                                                    true) }
                                                fill
                                            >Delete server
                                            </EuiButton>
                                        ) }

                                        { areYouSureState && (
                                            <>
                                                <div
                                                    className="are-you-sure">Delete { server ? server.name : 'this server' }?
                                                </div>
                                                <DangerActionsStyled>
                                                    <EuiButton
                                                        size="s"
                                                        color="danger"

                                                        onClick={ handleDelete }
                                                        isLoading={ deleteSending }
                                                        fill
                                                    >
                                                        Yes, delete
                                                    </EuiButton>

                                                    <EuiButton
                                                        size="s"
                                                        onClick={ () => setAreYouSureState(
                                                            false) }
                                                    >
                                                        Cancel
                                                    </EuiButton>
                                                </DangerActionsStyled>
                                            </>
                                        ) }
                                    </DeleteServerZoneStyled>
                                </ColumnStyled>
                            </ManagementGridStyled>
                        </EditSurfaceStyled>
                    </StyledEditWrapper>
                </>
            ) }

            { isTagsModalOpen && (
                <TagsModal close={ () => setIsTagsModalOpen(false) }/>
            ) }
        </main>
    );
};

export default ServerEditPage;
